import { Typography } from '@mui/material';
import { Link } from 'react-router-dom';

export default function CommunityUserLink({ communityName }: { communityName: string }) {
    if (!communityName) return null;

    const deletedUser = 'Gelöschter Vanlifer';

    if (communityName === deletedUser) {
        return (
            <Typography
                component="span"
                sx={{
                    color: 'primary.main',
                    fontWeight: 'inherit',
                    fontSize: 'inherit',
                    lineHeight: 'inherit',
                    textDecoration: 'none',
                }}
            >
                {deletedUser}
            </Typography>
        )
    }

    return (
        <Typography
            component={Link}
            to={`/vanlifer/Community/Profile/${communityName}`}
            sx={{
                color: 'primary.main',
                fontWeight: 'inherit',
                fontSize: 'inherit',
                lineHeight: 'inherit',
                textDecoration: 'none',
                '&:hover': { textDecoration: 'underline' }
            }}
            onClick={() => {
                // Pragmatic workaround to not break any other components by setting scroll position globally
                // Delay scrolling to top to let the routing happen first
                setTimeout(() => {
                    window.scrollTo(0, 0);
                }, 0);
            }}
        >
            {communityName}
        </Typography>
    );
}
